<!--Top bar-->
<caass-section-selector (SectionSelected)="onSectionSelected($event)"> </caass-section-selector>

<!--Display Window-->
<div>
	<!--Course Details-->
	<div class="CourseDetails">
		<div class="InfoHeading">
			<h4>Course Details:</h4>
		</div>

		<div class="CouseGrid">
			<label>Course Number:</label>
			<label>{{ CourseNumber }}</label>

			<label>Section Number:</label>
			<label>{{ SectionNumber }}</label>

			<label>Course Name:</label>
			<label>{{ CourseName }}</label>

			<label>Description:</label>
			<label>{{ Description }}</label>

			<label>Department:</label>
			<label>{{ Department }}</label>
		</div>
	</div>

	<!--Section Details-->
	<caass-section-details [SectionID]="SectionID" [SemesterID]="SemesterID"> </caass-section-details>

	<!--Student Details-->
	<caass-student-details [SectionID]="SectionID"> </caass-student-details>
</div>
